import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { FileUpload } from '@/presentation/components/index.js';
import { useApp } from '@/presentation/hooks/use-app.js';
import { DOC_CATEGORIES } from '@/shared/constants/document-categories.js';

interface Props {
    open: boolean;
    category: string | null;
    uploading: boolean;
    onFileSelected: (file: File) => Promise<boolean>;
    onClose: () => void;
}

export function UploadClientDocumentDialog({ open, category, uploading, onFileSelected, onClose }: Props) {
    const { translate } = useApp();
    const [error, setError] = useState('');

    const handleFileSelected = async (file: File) => {
        setError('');
        try {
            const shouldClose = await onFileSelected(file);
            if (shouldClose) {
                onClose();
            }
        } catch {
            setError(translate('errors.generic'));
        }
    };

    const handleClose = () => {
        if (uploading) {
            return;
        }
        setError('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{translate('documents.uploadFile')}</DialogTitle>
            <DialogContent>
                <FileUpload onFileSelected={handleFileSelected} maxSize={20 * 1024 * 1024} uploading={uploading} hint={DOC_CATEGORIES.find((c) => c.key === category)?.label} />
                {error && (
                    <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
                        {error}
                    </Typography>
                )}
            </DialogContent>
        </Dialog>
    );
}
